import React from "react"
import * as styles from "./VideoEmbed.module.scss"

const VideoEmbed = ({ title, youtubeUrl }) => {

    
  const getEmbedUrl = (url) => {
    try {
      const u = new URL(url);
      let id = u.searchParams.get("v");
      if (!id && u.hostname === "youtu.be") id = u.pathname.slice(1);
      return id ? `https://www.youtube-nocookie.com/embed/${id}` : null;
    } catch {
      return null;
    }
  };

  const embedUrl = getEmbedUrl(youtubeUrl);

  return (
    <div
      className={` global-spacing-top ${styles.videoWrapper}`}
      aria-label={title}
    >
      <div className={styles.inner}>
        {embedUrl ? (
          <iframe
            src={embedUrl}
            title={title}
            loading="lazy"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
          />
        ) : (
          <p>Invalid YouTube link</p>
        )}
      </div>
    </div>
  )
}

export default VideoEmbed
